'use strict';

// Browser-compatible QR encoder vendored from qrcode-terminal's MIT-licensed
// QRCode implementation. Keeping it local avoids runtime network dependencies.
module.exports = require('./QRCode');
